import { differenceInDays } from 'date-fns';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { currentPosAgencySelector } from 'src/features/pos';
import { useAgencies } from 'src/hooks';

export type AlertSubscriptionLevel = 'ALERT' | 'WARNING' | 'NONE';

const ALERT_SUBSCRIPTION_DAYS = 20;

export const useSubscriptionAlert = () => {
  const [warningRefLevel, setWarningLevel] = useState<AlertSubscriptionLevel>('NONE');
  const [expireAt, estExpireAt] = useState<Date | null>(null);

  const agencyPos = useSelector(currentPosAgencySelector);
  const { allAgencies } = useAgencies();

  useEffect(() => {
    if (!agencyPos) {
      setWarningLevel('NONE');
      return;
    }
    const currentAgency = allAgencies.find((agency) => agency.id === agencyPos);

    if (!currentAgency) {
      setWarningLevel('ALERT');
      return;
    }

    if (!currentAgency.fullFeaturesExpiredAt) {
      setWarningLevel('ALERT');
      return;
    }

    const today = new Date();

    const expireAt = new Date(currentAgency.fullFeaturesExpiredAt);
    estExpireAt(expireAt);

    const diffInDays = differenceInDays(expireAt, today);
    if (diffInDays <= 0) {
      setWarningLevel('ALERT');
      return;
    }

    if (diffInDays <= ALERT_SUBSCRIPTION_DAYS) {
      setWarningLevel('WARNING');
      return;
    }

    setWarningLevel('NONE');
  }, [agencyPos, allAgencies]);

  return { level: warningRefLevel, expireAt: expireAt };
};
